import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    statuses: null,
    users: null,
    userInfo: null,
    weeks: null,
    filter: null
  },
  mutations: {
    update(state, {data}) {
      state.weeks = data.weeks;
      state.users = data.users;
      state.userInfo = data.userInfo;
      state.statuses = data.statuses;
    }
  },
  actions: {
    async getUserDossier({commit}, {userId}) {
      try {
        const {data} = await api.get(userId);
        commit('update', {data});
      } catch (e) {
        throw e;
      }
    },
    async checkAccess({commit}, {userId}) {
      try {
        await api.post(userId, {});
      } catch (e) {
        throw e;
      }
    }
  }
});
